module.exports = __webpack_public_path__ + "static/media/flag-tg.8fa1a613.webp";